import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { RealtimeProvider } from "./context/RealtimeEventsContext";
import { PermissionProvider } from "./context/PermissionContext";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <RealtimeProvider>
        <PermissionProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            <AppRoutes />
          </BrowserRouter>
        </PermissionProvider>
      </RealtimeProvider>
    </I18nextProvider>
  );
}

export default App;
